import { render, staticRenderFns } from "./TextListComponent.vue?vue&type=template&id=3421def6&scoped=true"
import script from "./TextListComponent.vue?vue&type=script&lang=js"
export * from "./TextListComponent.vue?vue&type=script&lang=js"
import style0 from "./TextListComponent.vue?vue&type=style&index=0&id=3421def6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421def6",
  null
  
)

export default component.exports